import { render, staticRenderFns } from "./ImgAi.vue?vue&type=template&id=0d5fc18c&scoped=true"
import script from "./ImgAi.vue?vue&type=script&lang=js"
export * from "./ImgAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5fc18c",
  null
  
)

export default component.exports